import React from "react";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  Link,
} from "@mui/material";

const TermsAndConditions = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Terms and Conditions – Econirmit
      </Typography>

      <Box my={3}>
        <Typography variant="h6">1. Acceptance of Terms</Typography>
        <Typography paragraph>
          By accessing this website (
          <Link href="https://econirmit.com" target="_blank" rel="noopener">
            https://econirmit.com
          </Link>
          ), you agree to comply with these terms and conditions.
        </Typography>
        <Typography paragraph>
          Do not use the website if you do not accept all terms stated herein.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">2. Terminology</Typography>
        <Typography paragraph>
          "Client", "You", "Your" refers to the user accessing the website.
        </Typography>
        <Typography paragraph>
          "The Company", "We", "Our", "Us" refers to Econirmit.
        </Typography>
        <Typography paragraph>
          "Party", "Parties" refers to both the user and the company.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">3. Cookies</Typography>
        <Typography paragraph>
          This site uses cookies in accordance with the Privacy Policy.
        </Typography>
        <Typography paragraph>
          Cookies enhance functionality and may be used by affiliate/advertising partners.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">4. License and Use Restrictions</Typography>
        <Typography paragraph>
          All content is owned by Econirmit and/or its licensors.
        </Typography>
        <Typography paragraph>
          You may access the website for personal use only.
        </Typography>
        <Typography paragraph>You may not:</Typography>
        <List>
          <ListItem>Republish, sell, rent, or sublicense material</ListItem>
          <ListItem>Reproduce or redistribute content</ListItem>
        </List>
      </Box>

      <Box my={3}>
        <Typography variant="h6">5. User Comments</Typography>
        <Typography paragraph>
          Users may post comments in specific areas. Comments reflect individual opinions, not those of Econirmit.
        </Typography>
        <Typography paragraph>
          Econirmit is not liable for user-generated comments. We reserve the right to monitor and remove inappropriate comments.
        </Typography>
        <Typography paragraph>By posting comments, you confirm:</Typography>
        <List>
          <ListItem>You have the right to do so</ListItem>
          <ListItem>Comments do not infringe on third-party rights</ListItem>
          <ListItem>Comments are not offensive, defamatory, or illegal</ListItem>
          <ListItem>Comments are not used for promotion or solicitation</ListItem>
          <ListItem>You grant Econirmit the right to use and modify your comments across media</ListItem>
        </List>
      </Box>

      <Box my={3}>
        <Typography variant="h6">6. Hyperlinking to Our Content</Typography>
        <Typography paragraph>The following may link without prior approval:</Typography>
        <List>
          <ListItem>Government agencies</ListItem>
          <ListItem>Search engines</ListItem>
          <ListItem>News organizations</ListItem>
          <ListItem>Online directory distributors</ListItem>
          <ListItem>System-wide accredited businesses (excluding certain non-profits)</ListItem>
        </List>
        <Typography paragraph>Links must:</Typography>
        <List>
          <ListItem>Not be deceptive</ListItem>
          <ListItem>Not imply false sponsorship or endorsement</ListItem>
          <ListItem>Fit the context of the linking site</ListItem>
        </List>
        <Typography paragraph>We may approve links from:</Typography>
        <List>
          <ListItem>Consumer/business information sources</ListItem>
          <ListItem>.com communities</ListItem>
          <ListItem>Charitable associations</ListItem>
          <ListItem>Internet portals</ListItem>
          <ListItem>Professional firms and educational institutions</ListItem>
        </List>
        <Typography paragraph>To request a link, send an email with your organization’s details and URLs.</Typography>
        <Typography paragraph>Approved organizations may link using:</Typography>
        <List>
          <ListItem>Our corporate name</ListItem>
          <ListItem>Direct URLs</ListItem>
          <ListItem>Descriptions relevant to the context</ListItem>
        </List>
        <Typography paragraph>
          Use of logos or graphics is prohibited without a trademark license.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">7. iFrames</Typography>
        <Typography paragraph>
          Creating frames around our webpages is not allowed without prior written permission.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">8. Content Liability</Typography>
        <Typography paragraph>
          We are not responsible for content on external websites linking to us.
        </Typography>
        <Typography paragraph>
          You agree to defend us against claims arising from your website.
        </Typography>
        <Typography paragraph>
          No links should be associated with libelous, obscene, or infringing content.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">9. Privacy</Typography>
        <Typography paragraph>
          Please refer to our Privacy Policy for information regarding your data.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">10. Reservation of Rights</Typography>
        <Typography paragraph>
          We may request removal of any link to our site and may change our linking policy at any time.
        </Typography>
        <Typography paragraph>
          Continued linking constitutes agreement to these terms.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">11. Removal of Links</Typography>
        <Typography paragraph>
          If you find any offensive link on our website, you may contact us.
        </Typography>
        <Typography paragraph>
          We are not obligated to remove such links or respond.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">12. Disclaimer</Typography>
        <Typography paragraph>
          We do not guarantee the accuracy, completeness, or availability of website content.
        </Typography>
        <Typography paragraph>
          To the extent allowed by law, we exclude all warranties and conditions.
        </Typography>
        <Typography paragraph>This does not limit or exclude liability for:</Typography>
        <List>
          <ListItem>Death or personal injury</ListItem>
          <ListItem>Fraud or misrepresentation</ListItem>
          <ListItem>Any liability not legally excludable</ListItem>
        </List>
        <Typography paragraph>
          As long as the site is offered free of charge, we are not liable for any loss or damage of any kind.
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsAndConditions;
